/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../label/defs.defs.js'

const $nsid = 'com.atproto.temp.fetchLabels'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  since: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 250 }),
      50,
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  labels: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/**
 * Fetch all labels from a labeler created after a certain date.
 * @deprecated use queryLabels or subscribeLabels instead
 */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
